import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=2e7ef853&scoped=true&"
import script from "./ShareLinks.vue?vue&type=script&lang=js&"
export * from "./ShareLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ef853",
  null
  
)

export default component.exports